// extracted by mini-css-extract-plugin
module.exports = {"summary":"PaymentSummary_summary__1jxyW","data":"PaymentSummary_data__260O5","value":"PaymentSummary_value__35s0s"};